// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard_container__dnUd3 {
  flex-direction: column;
  align-items: baseline;
  margin: 48px 0px;
  width: 100%;
}
.Dashboard_wrapper__sCYRN {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 5%;
}
.Dashboard_container__dnUd3,
.Dashboard_card__Ocjlk {
  display: flex;
  justify-content: space-between;
}
.Dashboard_card__Ocjlk {
  border: 2px solid rgba(95, 109, 126, 0.24);
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  border-radius: 16px;
  cursor: pointer;
  flex-direction: column;
  height: 205px;
  padding: 24px;
  transition: border 200ms ease-in-out;
  width: 205px;
}
.Dashboard_card__Ocjlk:hover,
.Dashboard_carouselPolaznikCard__JDx3j:hover {
  border: 2px solid #5f6d7e;
  transition: border 200ms ease-in-out;
}

.Dashboard_iconContainer__NO-qM {
  background-color: rgba(95, 109, 126, 0.08);
  border-radius: 8px;
  height: 40px;
  padding: 8px;
  width: 40px;
}
.Dashboard_cardTextContainer__RMZ5t {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.Dashboard_cardNumberText__xcvm\\+ {
  color: #5f6d7e;
  cursor: pointer;
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.Dashboard_cardTitleContainer__kd2F0 {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.Dashboard_cardText__m8qGe {
  color: #5f6d7e;
  text-transform: uppercase;
}
.Dashboard_cardText__m8qGe,
.Dashboard_carouselItemHeading__Z1V5W {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
  cursor: pointer;
}
.Dashboard_arrowIcon__hmGxR {
  height: 12px;
  width: 6px;
}
.Dashboard_carouselCard__N6ERW,
.Dashboard_carouselPolaznikCard__JDx3j {
  cursor: pointer;
  row-gap: 16px;
}
.Dashboard_carouselCard__N6ERW,
.Dashboard_carouselPolaznikCard__JDx3j,
.Dashboard_carouselItemTextContainer__0XyuE {
  display: flex;
  flex-direction: column;
}
.Dashboard_carouselPolaznikCard__JDx3j {
  border: 2px solid #e0e0e0;
  padding: 16px;
  border-radius: 8px;
}
.Dashboard_carouselImage__bMxMy {
  height: 248px;
  width: auto;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.Dashboard_image__6kY\\+I {
  width: 100%;
  height: 100%;
}
.Dashboard_carouselItemTextContainer__0XyuE {
  row-gap: 8px;
}
.Dashboard_carouselItemHeading__Z1V5W {
  color: #4d4d4d;
  white-space: pre-wrap;
}
.Dashboard_carouselItemTextRow__wVBPS {
  align-items: center;
  display: flex;
  column-gap: 8px;
}
.Dashboard_carouselItemIcon__vtUbb {
  height: 24px;
  width: 24px;
}
.Dashboard_carouselItemText__BK4RO {
  color: #9fa7b2;
  cursor: pointer;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.Dashboard_overlayContainer__pv402 {
  position: relative;
}
.Dashboard_overlay__jo40Q {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.Dashboard_overlayText__SzSxa {
  display: flex;
  align-items: center;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.016px;
}
.Dashboard_chevronIcon__UeMdV {
  stroke: #fff;
}
.Dashboard_carouselCard__N6ERW:hover .Dashboard_overlay__jo40Q,
.Dashboard_carouselPolaznikCard__JDx3j:hover .Dashboard_overlay__jo40Q {
  opacity: 1;
}

.Dashboard_mobileHeader__Uf\\+AC {
  display: none;
}

@media screen and (max-width: 1300px) {
  .Dashboard_mobileHeader__Uf\\+AC {
    display: block;
  }
}

@media screen and (max-width: 1200px) {
  .Dashboard_carouselImage__bMxMy {
    height: 235px;
    width: auto;
  }

  .Dashboard_carouselItemTextRow__wVBPS {
    width: 235px;
  }
}

@media screen and (max-width: 1030px) {
  .Dashboard_wrapper__sCYRN {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,OAAO;AACT;AACA;;EAEE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,0CAA0C;EAC1C,oDAAoD;EACpD,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,eAAe;EACf,aAAa;AACf;AACA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":[".container {\n  flex-direction: column;\n  align-items: baseline;\n  margin: 48px 0px;\n  width: 100%;\n}\n.wrapper {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  gap: 5%;\n}\n.container,\n.card {\n  display: flex;\n  justify-content: space-between;\n}\n.card {\n  border: 2px solid rgba(95, 109, 126, 0.24);\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  border-radius: 16px;\n  cursor: pointer;\n  flex-direction: column;\n  height: 205px;\n  padding: 24px;\n  transition: border 200ms ease-in-out;\n  width: 205px;\n}\n.card:hover,\n.carouselPolaznikCard:hover {\n  border: 2px solid #5f6d7e;\n  transition: border 200ms ease-in-out;\n}\n\n.iconContainer {\n  background-color: rgba(95, 109, 126, 0.08);\n  border-radius: 8px;\n  height: 40px;\n  padding: 8px;\n  width: 40px;\n}\n.cardTextContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n}\n.cardNumberText {\n  color: #5f6d7e;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.cardTitleContainer {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n.cardText {\n  color: #5f6d7e;\n  text-transform: uppercase;\n}\n.cardText,\n.carouselItemHeading {\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  cursor: pointer;\n}\n.arrowIcon {\n  height: 12px;\n  width: 6px;\n}\n.carouselCard,\n.carouselPolaznikCard {\n  cursor: pointer;\n  row-gap: 16px;\n}\n.carouselCard,\n.carouselPolaznikCard,\n.carouselItemTextContainer {\n  display: flex;\n  flex-direction: column;\n}\n.carouselPolaznikCard {\n  border: 2px solid #e0e0e0;\n  padding: 16px;\n  border-radius: 8px;\n}\n.carouselImage {\n  height: 248px;\n  width: auto;\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n}\n.image {\n  width: 100%;\n  height: 100%;\n}\n.carouselItemTextContainer {\n  row-gap: 8px;\n}\n.carouselItemHeading {\n  color: #4d4d4d;\n  white-space: pre-wrap;\n}\n.carouselItemTextRow {\n  align-items: center;\n  display: flex;\n  column-gap: 8px;\n}\n.carouselItemIcon {\n  height: 24px;\n  width: 24px;\n}\n.carouselItemText {\n  color: #9fa7b2;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.overlayContainer {\n  position: relative;\n}\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 8px;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n.overlayText {\n  display: flex;\n  align-items: center;\n  color: #fff;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n.chevronIcon {\n  stroke: #fff;\n}\n.carouselCard:hover .overlay,\n.carouselPolaznikCard:hover .overlay {\n  opacity: 1;\n}\n\n.mobileHeader {\n  display: none;\n}\n\n@media screen and (max-width: 1300px) {\n  .mobileHeader {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .carouselImage {\n    height: 235px;\n    width: auto;\n  }\n\n  .carouselItemTextRow {\n    width: 235px;\n  }\n}\n\n@media screen and (max-width: 1030px) {\n  .wrapper {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Dashboard_container__dnUd3`,
	"wrapper": `Dashboard_wrapper__sCYRN`,
	"card": `Dashboard_card__Ocjlk`,
	"carouselPolaznikCard": `Dashboard_carouselPolaznikCard__JDx3j`,
	"iconContainer": `Dashboard_iconContainer__NO-qM`,
	"cardTextContainer": `Dashboard_cardTextContainer__RMZ5t`,
	"cardNumberText": `Dashboard_cardNumberText__xcvm+`,
	"cardTitleContainer": `Dashboard_cardTitleContainer__kd2F0`,
	"cardText": `Dashboard_cardText__m8qGe`,
	"carouselItemHeading": `Dashboard_carouselItemHeading__Z1V5W`,
	"arrowIcon": `Dashboard_arrowIcon__hmGxR`,
	"carouselCard": `Dashboard_carouselCard__N6ERW`,
	"carouselItemTextContainer": `Dashboard_carouselItemTextContainer__0XyuE`,
	"carouselImage": `Dashboard_carouselImage__bMxMy`,
	"image": `Dashboard_image__6kY+I`,
	"carouselItemTextRow": `Dashboard_carouselItemTextRow__wVBPS`,
	"carouselItemIcon": `Dashboard_carouselItemIcon__vtUbb`,
	"carouselItemText": `Dashboard_carouselItemText__BK4RO`,
	"overlayContainer": `Dashboard_overlayContainer__pv402`,
	"overlay": `Dashboard_overlay__jo40Q`,
	"overlayText": `Dashboard_overlayText__SzSxa`,
	"chevronIcon": `Dashboard_chevronIcon__UeMdV`,
	"mobileHeader": `Dashboard_mobileHeader__Uf+AC`
};
export default ___CSS_LOADER_EXPORT___;
